import React from "react";
import PortfolioNeonDark from "./Portfolio";


function App() {
  return <PortfolioNeonDark/>
}

export default App;
